import AbstractShape, {Dimensions, DimensionProperties} from "./AbstractShape";
import Length from "../../../../source/js/shared/models/Geometry/Length";
import DimensionLine from "../Lines/DimensionLine";
import OffsetLine from "../Lines/OffsetLine";

export class RightAngledTriangle extends AbstractShape {
	constructor( dimensions?: object ) {
		super( 'right-angled-triangle', dimensions );

		this.labelMappings = {
			base: 'width',
		};
	}

	getHeight(): Length {
		return this.cleanedPrimitives.height;
	}

	getBase(): Length {
		return this.cleanedPrimitives.base;
	}

	getLength(): Length {
		return this.cleanedPrimitives.height;
	}

	getWidth(): Length {
		return this.cleanedPrimitives.base;
	}

	getSideLenght(): Length {
		const hypotenuseSquared = this.getWidth().in_mm()**2 + this.getHeight().in_mm()**2;

		// Calculate the hypotenuse by taking the square root
		return Length.from_mm(Math.sqrt(hypotenuseSquared));
	}

	getDimensionProperties(): DimensionProperties {
		return { primary: 'height', secondary: 'base' };
	}

	getDimensionLines(ratio = 1, focusedElement = '', forceRender = false): DimensionLine[] {
		if(focusedElement.includes("cutout_measurement") || forceRender) {
			return [
				new DimensionLine( [this.getWidth().in_mm(), 0], [ this.getWidth().in_mm(), this.getHeight().in_mm() ], this.renderDimensionLabel( 'height' ), [40, 0], ratio, this.getDimensionLineType('measurements-right-angled-triangle-height', focusedElement, forceRender) ), // Vertical line
				new DimensionLine( [0, 0], [ this.getWidth().in_mm(), 0 ], this.renderDimensionLabel( 'width' ), [0, -40], ratio, this.getDimensionLineType('measurements-right-angled-triangle-base', focusedElement, forceRender) ), // Horizontal line

				new DimensionLine( [0, 0], [ this.getWidth().in_mm(), this.getHeight().in_mm() ], this.renderDimensionLabel( 'side_length', this.getSideLenght().in_cm() ), [-40, 40], ratio ), // Horizontal line
			];
		}

		return [];
	}

	getDefaultDimensions(): Dimensions {
		return {
			height: 50,
			base: 50,
		};
	}

	getDefaultCutoutDimensions(parentShape: AbstractShape): Dimensions {
		const enclosingRectangle = parentShape.getEnclosingRectangle();
		const width = enclosingRectangle.width();
		const height = enclosingRectangle.height();

		return {
			height: height.divide(2).in_cm(),
			base: width.divide(2).in_cm(),
		};
	}
}
